<section class="mt-2 grid gap-2">
  <h2 class="m-0 text-xl font-semibold leading-tight text-text">{{ publisherTitle() }}</h2>
  <hr class="mb-3 border-0 border-t border-subtle" />

  @if (isLoading()) {
    <p class="text-sm text-text-muted">Loading publisher content...</p>
  } @else if (hasError() && collections().length === 0) {
    <p class="text-sm text-text-muted">
      Publisher content is unavailable right now. Please try again.
    </p>
  } @else if (collections().length === 0) {
    <p class="text-sm text-text-muted">No content is available for this publisher right now.</p>
  } @else {
    <div appOrderedMasonry>
      @for (collection of collections(); track trackByCollectionId($index, collection)) {
        <div appOrderedMasonryItem>
          @if (collection.isCollection) {
            <app-collection-feed-card [collection]="collection"></app-collection-feed-card>
          } @else if (collection.numerons[0]; as numeron) {
            <app-numeron-card
              [numeron]="numeron"
              [numeronCollection]="collection"
              displayMode="feed"
            ></app-numeron-card>
          }
        </div>
      }
    </div>
  }

  @if (hasError() && collections().length > 0) {
    <p class="text-sm text-text-muted">More content could not be loaded. Please try again.</p>
  }

  @if (isLoadingMore()) {
    <p class="text-sm text-text-muted">Loading more...</p>
  }

  @if (hasMore()) {
    <div
      appInfiniteScrollSentinel
      [disabled]="isLoading() || isLoadingMore()"
      (reached)="loadMore()"
      class="h-4"
      aria-hidden="true"
    ></div>
  }
</section>
